import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { SellerApiService } from '../../../service/seller-api.service';

@Component({
  selector: 'app-common-attach-safety',
  templateUrl: './common-attach-safety.component.html',
  styleUrls: ['./common-attach-safety.component.scss']
})
export class CommonAttachSafetyComponent implements OnInit, OnChanges {

  @Input() uploadlinks: Array<any> = [];
  @Input() isInternalEditable: boolean;
  upload_links: Array<any> = [];
  @Input() isedit: boolean;
  isEditable: boolean;
  isViewUploadSection: boolean;
  scope_upload_links: Array<any> = [];
  isInternalProject: boolean;
  constructor(private sellerService: SellerApiService) { }


  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.upload_links  = [];
    if (typeof this.uploadlinks !== 'undefined') {
      if (Array.isArray(this.uploadlinks)) {
        this.upload_links = this.uploadlinks;
      } else {
        if (this.uploadlinks !== '[]') {
          this.upload_links = String(this.uploadlinks).split(',');
        }
      }
    }
    this.isInternalProject = this.isInternalEditable;
    this.isViewUploadSection = this.isedit;
    this.scope_upload_links = [];
  }

  // Call Edit Option
  callEditOption() {
    // this.isViewUploadSection = true;
  }
  // Call Save Option
  callSave() {
    // this.isViewUploadSection = false;
  }

  // Upload Files
onFileChange(event) {
  if (event.target.files && event.target.files.length > 0) {
    for (let index = 0; index < event.target.files.length; index++) {
      // tslint:disable-next-line:prefer-const
      let file = event.target.files[index];
      this.scope_upload_links.push(file);
      // tslint:disable-next-line:prefer-const
      let reader = new FileReader();
      reader.readAsDataURL(file); // read file as data url
      // tslint:disable-next-line:no-shadowed-variable
      reader.onload = (event: Event) => { // called once readAsDataURL is completed
        // this.imageurls.push(reader.result);
      };
    }
  }

}

// Call the Cancel uploaded images in Step 2 section
removebrowseAttachFiles(i): void {
  this.scope_upload_links.splice(i, 1);
}


   // Get the Thummail
   getFileThumail(url) {
    // tslint:disable-next-line:prefer-const
    let extension = url.split('.').splice(-1)[0].toLocaleLowerCase();
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif' || extension === 'svg') {
      return url;
    }
    let mainFileType = this.sellerService.getMainFileType(extension);
    if (mainFileType == null) {
      if (extension === 'mp3' || extension === 'ogg' || extension === 'wav'
        || extension === 'webm' || extension === 'mmf' || extension === 'm4p' || extension === 'msv') {
        mainFileType = 'audio';
      } else if (extension === 'flv'
        || extension === 'mov' || extension === 'mp4' || extension === 'avi' || extension === 'mpeg' || extension === 'wmv') {
        mainFileType = 'video';
      } else {
        mainFileType = 'other';
      }
      return this.sellerService.getThumbnailImages(mainFileType, url);
    }else {
      return this.sellerService.getThumbnailImages(mainFileType, url);
    }

  }

  getFileNameSplit(url) {
    // tslint:disable-next-line:prefer-const
    let value = url.split('_X_').pop();
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/common/common-attach-safety/common-attach-safety.component.ts